import { QueryClient } from "@tanstack/react-query";

/**
 * `offlineFirst` matters here: the device is regularly on a bad site
 * connection, and queries must serve cache rather than hang.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 24 * 60 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
      networkMode: "offlineFirst",
    },
    mutations: {
      networkMode: "offlineFirst",
    },
  },
});
